module.exports = __webpack_public_path__ + "media/images/badge/tuttologo_secondary-82ba6e4795bb5ce67359e1a22ac887f6.png";